import { isObjectTypeId, normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useEffect } from 'react';
import { Metrics } from '../../metrics/Metrics';
import Raven from 'raven-js';
export const useNormalizeObjectTypeId = ({
  objectTypeOrId,
  componentName
}) => {
  const notObjectTypeId = !isObjectTypeId(objectTypeOrId);
  const objectTypeId = normalizeTypeId(objectTypeOrId);
  useEffect(() => {
    if (notObjectTypeId && objectTypeOrId) {
      const wasNormalized = objectTypeOrId !== objectTypeId;
      Metrics.counter('legacy-object-type-usage', {
        componentName,
        objectTypeNotNormalized: wasNormalized ? '' : objectTypeOrId
      }).increment();
    }
  }, [componentName, notObjectTypeId, objectTypeId, objectTypeOrId]);
  useEffect(() => {
    if (!objectTypeOrId) {
      Raven.captureException(new Error('Missing objectTypeId'));
    }
  }, [componentName, objectTypeOrId]);
  return objectTypeId;
};